<template>
  <div id="agregar-documento-expediente">
    <v-file-input
        v-show="false"
        show-size
        label="Seleccionar Archivo PFD"
        type="file"
        ref="anexoDocumento"
        name="anexo"
        id="anexo"
        accept=".pdf"
        @change="seleccion"
      >
    </v-file-input>
    <v-form ref="agregarDocumentoExpediente" v-model="esformularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Agregar Documento a Expediente
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <custom-autocomplete
              cols="12"
              v-model="expediente.idDocumento"
              label="Documento"
              :items="this.setDocumentosAgregar"
              item-text="descripcion"
              item-value="id"
              @change="setOrdenDocumento()"
              :rules="[mixReglas.requerido]"
              clearable>
            </custom-autocomplete>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" md="7" class="grey lighten-3" style="height:400px">
              <!-- si existe una ruta de archivo se carga la vista previa -->
              <template
              v-if="rutaArchivo">
              <VistaPreviaPdf
                :rutaArchivo="this.rutaArchivo" />
              </template>
              <!-- si no existe una ruta de archivo se muestra boton para seleccionar archivo -->
              <template
                v-else>
                  <v-row justify="center" align="center" style="height:100%">
                    <custom-button
                    tipo="agregar"
                    label="Cargar Archivo"
                    iconText="fa-file-pdf"
                    @click="seleccionarArchivo">
                      <v-icon left>
                        fa-file-pdf
                      </v-icon>
                    </custom-button>
                  </v-row>
              </template>
            </v-col>
            <v-col cols="12" md="5">
              <v-row
              v-if="rutaArchivo"
              class="mx-4"
              justify="space-between"
              align="center">
                <span>{{nombreArchivoSeleccionado}}</span>
                <custom-button
                  tipo="formCancelar"
                  label="Cambiar"
                  @click="seleccionarArchivo">
                </custom-button>
              </v-row>
              <custom-text-field
                v-model="expediente.referencia"
                label="Referencia"
                required>
              </custom-text-field>
              <custom-text-area
                v-model="expediente.observaciones"
                label="Observaciones"
                required>
              </custom-text-area>
              <template v-if="progreso">
                <v-row class="mx-4 mt-2" justify="center" align="center">
                  <span>Subiendo PDF</span>
                  <v-progress-linear
                    height="25"
                    :value="progreso"
                    color="blue darken-1"
                    dark
                  >
                    <h3>{{ progreso }}</h3>
                  </v-progress-linear>
                </v-row>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click.prevent="guardar"
            :disabled="!esformularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import VistaPreviaPdf from '@/components/VistaPreviaPdf.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import mixExpedientes from '../mixExpedientes';
import mixSubirArchivo from '@/helpers/mixSubirArchivo';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'AgregarDocumentoExpediente',
  mixins: [mixExpedientes, mixSubirArchivo],
  props: {
    idReferencia: {
      type: String,
      required: true,
    },
    moduloExpedienteOrigen: {
      type: String,
      required: true,
    },
    catalogoExpediente: {
      type: Array,
      required: true,
    },
    expedientePorContrato: {
      type: Array,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomTextField,
    CustomButton,
    CustomAutocomplete,
    CustomTextArea,
    VistaPreviaPdf,
  },
  data() {
    return {
      esformularioValido: false,
      enviandoFormulario: false,
      nombreArchivoSeleccionado: '',
      progreso: null,
      rutaArchivo: null,
      documentos: [],
      expediente: {
        idDocumento: '',
        idObra: null,
        idLicitacion: null,
        idAdjudicacionDirecta: null,
        idContrato: null,
        publicKey: '', // id publico del documento subido
        referencia: '',
        orden: null,
        existe: false,
        aplica: true,
        observaciones: '',
      },
    };
  },
  methods: {
    // Set de id referencia segun sea el modulo de donde se esta creando el expediente
    setIdReferencia() {
      switch (this.moduloExpedienteOrigen) {
        case 'contratos':
          this.expediente.idContrato = this.idReferencia;
          break;
        case 'planeacion':
          this.expediente.idObra = this.idReferencia;
          break;
        case 'licitaciones':
          this.expediente.idLicitacion = this.idReferencia;
          break;
        case 'adjudicacionDirecta':
          this.expediente.idAdjudicacionDirecta = this.idReferencia;
          break;
        default: break;
      }
    },
    async guardar() {
      // si existe una ruta de archivo, se sube el archivo al servidor
      this.enviandoFormulario = true;
      if (this.rutaArchivo) {
        const datosArchivo = this.setDatosArchivo();
        await this.mixSubirArchivo(datosArchivo);
      }
      // se agrega el documento al expediente
      await this.mixAgregarExpediente();
    },
    setDatosArchivo() {
      const datos = {
        nombre: `${this.contrato.numero}_${this.mixSetEtapa(this.setDocumentosAgregar
          .find((documento) => documento.id === this.expediente.idDocumento).etapa)}_${this.setDocumentosAgregar
          .find((documento) => documento.id === this.expediente.idDocumento).descripcion}${this.expediente.referencia ? '_' : ''}${this.expediente.referencia ? this.expediente.referencia : ''}`,
        path: `${this.contrato.ejercicio}/${this.contrato.numero}`,
      };
      return datos;
    },
    seleccionarArchivo() {
      document.getElementById('anexo').click();
    },
    setOrdenDocumento() {
      const documentoSeleccionado = this.catalogoExpediente
        .find((documento) => documento.id === this.expediente.idDocumento);
      this.expediente.orden = documentoSeleccionado.orden;
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.agregarDocumentoExpediente.reset();
    },
  },
  computed: {
    // se establecen los documentos disponibles para seleccion en el select
    setDocumentosAgregar() {
      const documentosAgregar = [];
      this.catalogoExpediente.forEach((item) => {
        const index = this.expedientePorContrato
          .findIndex((element) => element.idDocumento === item.id);
        // si el documento no existe en el expediente o es del tipo que se repite se agrega.
        if (index === -1 || item.seRepite) {
          documentosAgregar.push(item);
        }
      });
      return documentosAgregar;
    },
  },
  mounted() {
    this.setIdReferencia();
    eventBus.$on('seCargoArchivo', (archivo) => {
      this.expediente.publicKey = archivo.data.public_key;
      this.expediente.existe = true;
      this.expediente.aplica = true;
    });
  },

};
</script>

<style>

</style>
